module.exports = __webpack_public_path__ + "static/img/KO.aeac29a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/KO.png
// module id = 2WOo
// module chunks = 1